import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c(VTabs,{attrs:{"centered":""}},[_c(VTab,{on:{"click":function($event){_vm.tab = 1}}},[_c(VIcon,{attrs:{"left":""}},[_vm._v("mdi-arrange-bring-to-front")]),_vm._v("Herança\n    ")],1),_c(VTabItem,{staticClass:"heranca-item"},[_c('heranca')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }